import React from 'react';
import { WebsiteDesignProps } from './types';
import { Circle } from 'lucide-react';

const JapaneseZen: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Kyoto Harmony";

    return (
        <div className="bg-[#fcfaf5] text-[#2c2c2c] min-h-screen font-serif flex relative overflow-hidden">
            {/* Red Sun */}
            <div className="absolute top-20 right-20 w-64 h-64 bg-[#bc002d] rounded-full opacity-90 z-0 mix-blend-multiply"></div>

            {/* Vertical Nav - Left */}
            <nav className="w-24 border-r border-[#e0dacb] h-screen fixed left-0 top-0 bg-[#fcfaf5] z-20 flex flex-col items-center py-12">
                 <div className="writing-vertical-rl text-2xl font-bold tracking-[0.5em] uppercase text-[#2c2c2c]" style={{writingMode: 'vertical-rl'}}>
                     {schoolName}
                 </div>
                 <div className="mt-auto flex flex-col gap-8 items-center text-[#2c2c2c]/60">
                     <Circle size={12} className="fill-current" />
                     <Circle size={12} />
                     <Circle size={12} />
                 </div>
            </nav>

            <main className="ml-24 w-full relative z-10 container mx-auto px-12 md:px-24 py-20 flex flex-col justify-center min-h-screen">
                 <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                     <div>
                         <h1 className="text-5xl md:text-7xl font-light leading-snug mb-8">
                             Stillness in <br/> Motion.
                         </h1>
                         <p className="text-lg text-[#595959] leading-loose mb-12 max-w-md border-l-2 border-[#bc002d] pl-6">
                             We focus on focus itself. A curriculum designed to cultivate mindfulness, precision, and mastery in every subject.
                         </p>
                         <div className="flex gap-8 group cursor-pointer">
                             <div className="text-sm font-bold uppercase tracking-widest border-b border-[#2c2c2c] pb-2 group-hover:text-[#bc002d] group-hover:border-[#bc002d] transition-colors">
                                 Explore Path
                             </div>
                             <div className="text-sm font-bold uppercase tracking-widest border-b border-transparent pb-2 text-[#999] group-hover:text-[#bc002d] transition-colors">
                                 Inquire
                             </div>
                         </div>
                     </div>
                     <div className="relative">
                         <div className="w-full h-[600px] overflow-hidden bg-[#e6e2d6] relative">
                             <img src="https://images.unsplash.com/photo-1528360983277-13d9012356ee?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover opacity-80 mix-blend-darken grayscale-[30%]" alt="Zen Garden" />
                             <div className="absolute bottom-8 right-8 writing-vertical-rl text-white font-bold text-xl tracking-widest mix-blend-difference" style={{writingMode: 'vertical-rl'}}>
                                 自然と調和
                             </div>
                         </div>
                     </div>
                 </div>

                 <div className="mt-32 border-t border-[#e0dacb] pt-12 flex justify-between items-end text-sm text-[#999] font-sans tracking-widest">
                      <div>
                          ADDRESS: <br/> HONSHU DISTRICT 1
                      </div>
                      <div>
                          PHILOSOPHY: <br/> KAIZEN (IMPROVEMENT)
                      </div>
                      <div>
                          SINCE: <br/> 1954
                      </div>
                 </div>
            </main>
        </div>
    );
};

export default JapaneseZen;
